module.exports = __webpack_public_path__ + "img/banner-2.f491c5fc.png";